import ObjectCard from './ObjectCard'
import { ParsedObject } from '../../types'
import { Grid } from '@mui/material'

export interface ObjectsGridProps {
    objects: ParsedObject[]
    hasMoreData: boolean
    isSelectionMode?: boolean
    selectedObjectIds?: number[]
    onToggleObjectSelection?: (objectId: number) => void
}

const ObjectsGrid: React.FC<ObjectsGridProps> = ({
    objects,
    hasMoreData,
    isSelectionMode = false,
    selectedObjectIds = [],
    onToggleObjectSelection,
}: ObjectsGridProps) => (
    <Grid container spacing={2}>
        {objects.map((object, index) => (
            <Grid item key={`object-${index}`} xs={12} sm={6} md={4} lg={3}>
                <ObjectCard
                    object={object}
                    hasMoreData={hasMoreData}
                    isSelectionMode={isSelectionMode}
                    isSelected={selectedObjectIds.includes(object.objectId)}
                    onToggleSelection={onToggleObjectSelection}
                />
            </Grid>
        ))}
    </Grid>
)

export default ObjectsGrid
